import IncorrectAnswer from "./IncorrectAnswer";

export default IncorrectAnswer;
